var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{attrs:{"link-class":"d-flex align-items-center"},on:{"click":function($event){_vm.skin = _vm.isDark ? 'light' : 'dark'}}},[_c('b-link',{staticClass:"nav-link"},[_c('feather-icon',{staticClass:"mr-50",attrs:{"size":"16","icon":`${_vm.isDark ? 'Sun' : 'Moon'}Icon`}}),_c('span',[_vm._v("Cambia tema")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }